import { buildDeserializer, buildSerializer } from "lib/serializerUtils";

export const BillingDocumentDefaults = {
  billingReference: null,
  billingRunId: null,
  calculatedBillingReference: "",
  detailsText: null,
  dueDate: 0,
  emailIds: null,
  exportErrors: "",
  exportWarnings: "",
  hasBeenReversed: false,
  hasCosmeticChanges: false,
  hasFinancialChanges: false,
  id: null,
  integrationAmountDueCents: null,
  integrationAmountPaidCents: null,
  integrationStatus: null,
  integrationSubtotalCents: null,
  integrationTotalTaxCents: null,
  invoiceNumber: null,
  issuedDate: null,
  issuerBusinessId: null,
  latestInterestChargeDate: null,
  ledgerEntriesGeneratedDateTime: null,
  livestockSaleIds: [],
  number: null,
  paymentBankingDetailsId: null,
  plannedPaymentDate: "",
  plannedPaymentNote: "",
  proceedsRetainedByBillingDocument: null,
  recipientBusinessId: null,
  reportJobs: [],
  status: null,
  totalAmountDollars: null,
  totalExTaxAmountDollars: null,
  totalExTaxAmountDollarsExported: null,
  totalTaxAmountDollars: null,
  totalTaxAmountDollarsExported: null,
  type: null,
  warnings: null,
  xeroInvoiceId: null,
};

const reportJobSerializerMap = {
  documentStatus: "document_status",
  id: "id",
  status: "status",
  file: "file",
  report: "report",
};

const proceedsRetainedByBillingDocumentSerializerMap = {
  glCode: "gl_code",
  integrationStatus: "integration_status",
  number: "number",
  totalAmountCents: "total_amount_cents",
  xeroInvoiceId: "xero_invoice_id",
};

export const serializeMap = {
  billingReference: "billing_reference",
  billingRunId: "billing_run_id",
  calculatedBillingReference: "calculated_billing_reference",
  created: "created",
  detailsText: "details_text",
  dueDate: "due_date",
  emailIds: "email_ids",
  exportErrors: "export_errors",
  exportWarnings: "export_warnings",
  hasBeenReversed: "has_been_reversed",
  hasCosmeticChanges: "has_cosmetic_changes",
  hasFinancialChanges: "has_financial_changes",
  id: "id",
  integrationAmountDueCents: "integration_amount_due_cents",
  integrationAmountPaidCents: "integration_amount_paid_cents",
  integrationStatus: "integration_status",
  integrationSubtotalCents: "integration_subtotal_cents",
  integrationTotalTaxCents: "integration_total_tax_cents",
  invoiceNumber: "invoice_number",
  issuedDate: "issued_date",
  issuerBusinessId: "issuer_business_id",
  lastModified: "last_modified",
  latestInterestChargeDate: "latest_interest_charge_date",
  ledgerEntriesGeneratedDateTime: "ledger_entries_generated_datetime",
  livestockSaleIds: "livestock_sale_ids",
  number: "number",
  paymentBankingDetailsId: "payment_banking_details_id",
  plannedPaymentDate: "planned_payment_date",
  plannedPaymentNote: "planned_payment_note",
  proceedsRetainedByBillingDocument:
    proceedsRetainedByBillingDocumentSerializerMap,
  recipientBusinessId: "recipient_business_id",
  reportJobs: reportJobSerializerMap,
  status: "status",
  totalAmountDollars: "total_amount_dollars",
  totalExTaxAmountDollars: "total_ex_tax_amount_dollars",
  totalExTaxAmountDollarsExported: "total_ex_tax_amount_dollars_exported",
  totalTaxAmountDollars: "total_tax_amount_dollars",
  totalTaxAmountDollarsExported: "total_tax_amount_dollars_exported",
  type: "type",
  xeroInvoiceId: "xero_invoice_id",
};

const nestedObjectMap = {
  report_jobs: "reportJobs",
  proceeds_retained_by_billing_document: "proceedsRetainedByBillingDocument",
};

export const serializeBillingDocument = buildSerializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);

export const deserializeBillingDocument = buildDeserializer(
  serializeMap,
  "billingDocument",
  nestedObjectMap,
);

export const serializeRetainedProceedsBillingDocument = buildSerializer(
  proceedsRetainedByBillingDocumentSerializerMap,
  "billingDocument",
);

export const deserializeRetainedProceedsBillingDocument = buildDeserializer(
  proceedsRetainedByBillingDocumentSerializerMap,
  "retainedProceedsBillingDocument",
);
